export const SURVEY_STARTUP = { type: 'SURVEY_STARTUP', typeId: 1 };
export const SURVEY_ESTABLISHED = { type: 'SURVEY_ESTABLISHED', typeId: 2 };
export const EXPORT_STARTUP = 'startup';
export const EXPORT_ESTABLISHED = 'estco';
export const NOTIFICATION_USER_DETAILS = 'NOTIFICATION_USER_DETAILS';
export const NOTIFICATION_USER_PASSWORD = 'NOTIFICATION_USER_PASSWORD';
